import { Link } from 'react-router-dom';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-charcoal border-t border-stone">
      <div className="max-w-7xl mx-auto px-6 py-20 md:py-32">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16 md:gap-12 mb-20">
          {/* Brand Section */}
          <div className="md:col-span-4 space-y-6">
            <Link to="/" className="flex items-center gap-3 group">
              <img 
                src="/logo.webp" 
                alt="VirtualStagePro" 
                className="w-10 h-10 rounded-xl shadow-soft transition-transform duration-500 group-hover:-translate-y-0.5"
              />
              <span className="text-xl font-serif font-medium tracking-tight text-alabaster">
                VirtualStagePro
              </span>
            </Link>
            <p className="text-sm text-sand font-light max-w-xs leading-relaxed">
              Transform empty rooms into stunning spaces. Virtual staging in 30 seconds.
            </p>
          </div>

          {/* Navigation Links */}
          <div className="md:col-span-8 grid grid-cols-2 md:grid-cols-4 gap-12 md:gap-8">
            {/* Product */}
            <div className="space-y-4">
              <div className="text-xs font-mono uppercase tracking-widest text-sand mb-6">
                Product
              </div>
              <nav className="space-y-3">
                <Link
                  to="/virtual-staging"
                  className="block text-sand hover:text-terracotta transition-colors duration-300 font-sans font-light text-sm"
                >
                  Virtual Staging
                </Link>
                <Link
                  to="/virtual-staging/styles"
                  className="block text-sand hover:text-terracotta transition-colors duration-300 font-sans font-light text-sm"
                >
                  Styles
                </Link>
                <Link
                  to="/virtual-staging/pricing"
                  className="block text-sand hover:text-terracotta transition-colors duration-300 font-sans font-light text-sm"
                >
                  Pricing
                </Link>
                <Link
                  to="/virtual-staging/before-after"
                  className="block text-sand hover:text-terracotta transition-colors duration-300 font-sans font-light text-sm"
                >
                  Before/After
                </Link>
                <Link
                  to="/virtual-staging/faq"
                  className="block text-sand hover:text-terracotta transition-colors duration-300 font-sans font-light text-sm"
                >
                  FAQ
                </Link>
              </nav>
            </div>

            {/* Audiences */}
            <div className="space-y-4">
              <div className="text-xs font-mono uppercase tracking-widest text-sand mb-6">
                For
              </div>
              <nav className="space-y-3">
                <Link
                  to="/virtual-staging/real-estate-agents"
                  className="block text-sand hover:text-terracotta transition-colors duration-300 font-sans font-light text-sm"
                >
                  Real Estate Agents
                </Link>
                <Link
                  to="/virtual-staging/photographers"
                  className="block text-sand hover:text-terracotta transition-colors duration-300 font-sans font-light text-sm"
                >
                  Photographers
                </Link>
                <Link
                  to="/virtual-staging/broker-teams"
                  className="block text-sand hover:text-terracotta transition-colors duration-300 font-sans font-light text-sm"
                >
                  Broker Teams
                </Link>
              </nav>
            </div>

            {/* Partners */}
            <div className="space-y-4">
              <div className="text-xs font-mono uppercase tracking-widest text-sand mb-6">
                Partners
              </div>
              <nav className="space-y-3">
                <Link
                  to="/partners/photographers"
                  className="block text-sand hover:text-terracotta transition-colors duration-300 font-sans font-light text-sm"
                >
                  Photographer Partners
                </Link>
                <Link
                  to="/partners/brokerages"
                  className="block text-sand hover:text-terracotta transition-colors duration-300 font-sans font-light text-sm"
                >
                  Brokerage Partners
                </Link>
              </nav>
            </div>

            {/* Company */}
            <div className="space-y-4">
              <div className="text-xs font-mono uppercase tracking-widest text-sand mb-6">
                Company
              </div>
              <nav className="space-y-3">
                <Link
                  to="/auth"
                  className="block text-sand hover:text-terracotta transition-colors duration-300 font-sans font-light text-sm"
                >
                  Sign In
                </Link>
                <a
                  href="mailto:support@virtualstagepro.ai"
                  className="block text-sand hover:text-terracotta transition-colors duration-300 font-sans font-light text-sm"
                >
                  Contact
                </a>
                <Link
                  to="/privacy"
                  className="block text-sand hover:text-terracotta transition-colors duration-300 font-sans font-light text-sm"
                >
                  Privacy Policy
                </Link>
                <Link
                  to="/terms"
                  className="block text-sand hover:text-terracotta transition-colors duration-300 font-sans font-light text-sm"
                >
                  Terms of Service
                </Link>
                <Link
                  to="/virtual-staging/interior-ai-alternative"
                  className="block text-sand hover:text-terracotta transition-colors duration-300 font-sans font-light text-sm"
                >
                  Interior AI Alternative
                </Link>
              </nav>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-stone">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div className="text-sm text-sand font-light">
              © {currentYear} VirtualStagePro. All rights reserved.
            </div>
            <div className="flex items-center gap-6">
              <a
                href="https://www.facebook.com/virtualstageproai"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sand hover:text-terracotta transition-colors duration-300 text-sm font-light"
                aria-label="Facebook"
              >
                Facebook
              </a>
              <a
                href="https://www.instagram.com/virtualstagepro.ai/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sand hover:text-terracotta transition-colors duration-300 text-sm font-light"
                aria-label="Instagram"
              >
                Instagram
              </a>
              {/* Uncomment when profiles are created
              <a
                href="https://twitter.com/virtualstagepro"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sand hover:text-terracotta transition-colors duration-300 text-sm font-light"
                aria-label="Twitter"
              >
                Twitter
              </a>
              <a
                href="https://linkedin.com/company/virtualstagepro"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sand hover:text-terracotta transition-colors duration-300 text-sm font-light"
                aria-label="LinkedIn"
              >
                LinkedIn
              </a>
              */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
